import React, { Component } from 'react'
import Button from 'components/button/button'

import {
	deleteOrganisation,
	openModal,
	logoutUser
} from 'state/actions'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import Icon from 'components/icon/icon'

import Radio from 'components/input/radio'

import {
	getCurrentAccount,
	getCurrentUser
} from 'state/selectors'

class ModalCloseAccount extends Component {
	item = {}
	state = {
		checkOptionStatus: false,
		activeRadio: null 
	}

	deleteOrganisation = otherAccount => {
		const {
			deleteOrganisation,
			logoutUser,
			openModal,
			history
		} = this.props

		const {
			activeRadio
		} = this.state

		deleteOrganisation({
			account: this.item,
			reason: activeRadio
		}, _ => {
			if (otherAccount) {
				history.push('/' + otherAccount.slug)
			}else{
				logoutUser()
			}
			
			this.successCallback()
		})
	}

	doAction = () => {
		const {
			setLoading,
			userData,
			allAccounts,
		} = this.props

		setLoading(true)

		let otherAccount = null

		userData.accounts.forEach(accountId => {
			const account = allAccounts[accountId]

			if (!otherAccount && account.id !== this.item.id) {
				otherAccount = account
			}
		})

		this.deleteOrganisation(otherAccount)
	}

	toggleCheckOption = _ => {
		this.setState({
			checkOptionStatus: !this.state.checkOptionStatus
		})
	}

	successCallback = _ => {
		this.props.setLoading(false)
		this.props.closeCallback()
	}

	componentWillMount = _ => {
		const {
			data
		} = this.props

		this.item = data
	}

	render() {
		const {
			closeCallback
		} = this.props

		const {
			activeRadio
		} = this.state

		let objectName
		let warningString = null

		const object = this.item

		if (object.name) {
			objectName = object.name
		}

		const options = [
			`It's too complicated`,
			`It isn't good value for money`,
			`I had some technical issues`,
			`It doesn't have enough features`,
			`I don't have time to get set up`
		]

		warningString = "Are you sure? This can't be undone!"

		return (
			<div>
				<div className={'modal-task borders'}>
					{objectName &&
						<h3>
							{objectName}
						</h3>
					}
				</div>
				<ul className={'radio-list'}>
					{options.map(option => {
						return (
							<li key={option}>
								<label>
									<Radio
										name={option}
										onChange={_ => { this.setState({activeRadio: option}) }}
										checked={activeRadio === option}
									/>
									<span>
										{ option }
									</span>
								</label>
							</li>
						)
					})}
				</ul>
				<div className="modal-warning">
					<Icon name="fe-alert-triangle" />
					<span>
						{warningString}
					</span>
				</div>
				<Button
					size={'big'}
					level={'high'}
					callback={this.doAction}
					label={'Delete organization'}
					icon={'check'}
					disabled={!activeRadio}
				/>
				<Button
					size={'big'}
					level={'low'}
					callback={closeCallback}
					label={'Cancel'}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		userData: getCurrentUser(state),
		accountData: getCurrentAccount(state),
		allAccounts: state.account.entities.accounts
	};
}

export default withRouter(connect(mapStateToProps, {
	deleteOrganisation,
	openModal,
	logoutUser
})(ModalCloseAccount))


// WEBPACK FOOTER //
// ./src/components/modal/modal-types/modal-close-account.jsx